// extracted by mini-css-extract-plugin
export var button = "_da-4";
export var hasDarkBackground = "_da-7";
export var hasLightBackground = "_da-6";
export var iconWrapper = "_da-0";
export var large = "_da-2";
export var medium = "_da-1";
export var small = "_da-5";
export var xsmall = "_da-3";